var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgDz(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7259_40784)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0C18.6274 0 24 5.37262 24 12C24 18.6274 18.6274 24 12 24C12 23.4783 10.4348 12 10.4348 12L12 0Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 24C5.37262 24 0 18.6274 0 12C0 5.37262 5.37262 0 12 0",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5783 9.69826L13.5937 11.0551L11.9992 10.5379L12.9853 11.8936L12.0008 13.2504L13.5948 12.7314L14.5809 14.087L14.5799 12.4107L16.1739 11.8917L14.5794 11.3746L14.5783 9.69826Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9955 15.3913C11.1225 15.3913 9.60417 13.8729 9.60417 12C9.60417 10.1271 11.1225 8.60869 12.9955 8.60869C13.5795 8.60869 14.129 8.75635 14.6087 9.01632C13.8561 8.28033 12.8269 7.82607 11.6911 7.82607C9.38592 7.82607 7.51725 9.69478 7.51725 12C7.51725 14.3051 9.38597 16.1738 11.6911 16.1738C12.8269 16.1738 13.8561 15.7196 14.6087 14.9836C14.129 15.2437 13.5795 15.3913 12.9955 15.3913Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7259_40784"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDz);
export default __webpack_public_path__ + "static/media/dz.ad2d9a1f95eb7cb9fac7865abf350e71.svg";
export { ForwardRef as ReactComponent };